import { Spotlight } from '@atlaskit/onboarding';
import { Stack, Text } from '@atlaskit/primitives/compiled';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React from 'react';
import { useIntl } from 'react-intl-next';

import messages from '../messages.tsx';
import type { SpotlightTourStepProps } from '../types.tsx';

export const ParentStep = ({ onDismiss }: SpotlightTourStepProps) => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onDismiss,
					text: formatMessage(messages.changeboardingOkButton),
				},
			]}
			actionsBeforeElement="2/2"
			dialogPlacement="left top"
			dialogWidth={300}
			heading={formatMessage(messages.changeboardingPageTwoTitle)}
			key="jira-filter-refinement-spotlight-popup-parent"
			target="jira-filter-refinement-spotlight-popup-parent"
			targetRadius={3}
		>
			<Stack space="space.150">
				<Text>{formatMessage(messages.changeboardingDescriptionParentHasReplacedEpic)}</Text>
			</Stack>
		</Spotlight>
	);
};
